var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78004 5.27997C6.92074 5.42049 6.99987 5.61113 7.00004 5.80997V6.18997C6.99774 6.38839 6.91893 6.57825 6.78004 6.71997L1.64004 11.85C1.54616 11.9446 1.41836 11.9979 1.28504 11.9979C1.15172 11.9979 1.02393 11.9446 0.930043 11.85L0.220043 11.14C0.125979 11.0478 0.0729713 10.9217 0.0729713 10.79C0.0729713 10.6583 0.125979 10.5321 0.220043 10.44L4.67004 5.99997L0.220043 1.55997C0.125386 1.46609 0.0721436 1.33829 0.0721436 1.20497C0.0721436 1.07166 0.125386 0.943858 0.220043 0.849974L0.930043 0.149974C1.02393 0.055318 1.15172 0.0020752 1.28504 0.0020752C1.41836 0.0020752 1.54616 0.055318 1.64004 0.149974L6.78004 5.27997Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.283c235f.svg";
export { ForwardRef as ReactComponent };